import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checked'
})
export class CheckedPipe implements PipeTransform {
  transform(selectedValues: string[], value: string): boolean {
    return selectedValues ? selectedValues.includes(value) : false;
  }
}
